import { routerApp } from '../app.module';
import { getCacheBustedTemplate } from '../app.route';

routerApp.directive('badge', function() {
    return {
        templateUrl: getCacheBustedTemplate('pages/directives/badge.html'),
        scope: {
            tooltip: '@',
            show: '=',
            label: '@',
        },
    }
});
